import React from 'react';
import '../styles/Himachal.css';
import logo from "../assets/logo3.webp";
import { Link, useLocation } from "react-router-dom";
import himachalData from '../data/himachal.json';
import himachalBanner from '../assets/himachal.png';

const imageMap = {
'../assets/shimla.png': require('../assets/shimla.png'),
'../assets/manali.png': require('../assets/manali.png'),
'../assets/dharamshala.png': require('../assets/dharamshala.png'),
'../assets/kullu.png': require('../assets/kullu.png'),
'../assets/spiti.png': require('../assets/spiti.png'),
'../assets/kasol.png': require('../assets/kasol.png'),
'../assets/kinnaur.png': require('../assets/kinnaur.png'),
'../assets/chail.png': require('../assets/chail.png'),
'../assets/tirthan.png': require('../assets/tirthan.png'),
'../assets/kufri.png': require('../assets/kufri.png'),
'../assets/jakhu.png': require('../assets/jakhu.png'),
'../assets/hadimba.png': require('../assets/hadimba.png'),
'../assets/baijnath.png': require('../assets/baijnath.png'),
'../assets/jwala.png': require('../assets/jwala.png'),
'../assets/chintpurni.png': require('../assets/chintpurni.png'),
'../assets/nainadevi.png': require('../assets/nainadevi.png'),
'../assets/birbilling.png': require('../assets/birbilling.png'),
'../assets/skiing.png': require('../assets/skiing.png'),
'../assets/triund.png': require('../assets/triund.png'),
'../assets/kullurafting.png': require('../assets/kullurafting.png'),
'../assets/kasolcamping.png': require('../assets/kasolcamping.png'),
'../assets/narkanda.png': require('../assets/narkanda.png'),
'../assets/biking.png': require('../assets/biking.png'),
'../assets/rockclimbing.png': require('../assets/rockclimbing.png'),
'../assets/hamptatrek.png': require('../assets/hamptatrek.png'),
'../assets/wildflower.png': require('../assets/wildflower.png'),
'../assets/himalayan.png': require('../assets/himalayan.png'),
'../assets/palampur.png': require('../assets/palampur.png'),
'../assets/manalsu.png': require('../assets/manalsu.png'),
'../assets/sterling.png': require('../assets/sterling.png'),
'../assets/zostel.png': require('../assets/zostel.png'),
'../assets/grandview.png': require('../assets/grandview.png'),
'../assets/dhauladhar.png': require('../assets/dhauladhar.png'),
'../assets/tajtheog.png': require('../assets/tajtheog.png'),
'../assets/applecountry.png': require('../assets/applecountry.png')
};

const Himachal = () => {
     const location = useLocation();
  return (
    <>
     <header className="contact-header over-banner">
        <div className="contact-logo">
          <img src={logo} alt="Tourly Logo" />
        </div>
        <nav className="contact-nav">
          <Link to="/">Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="contact-dropdown">
      <a href="#" className={`contact-dropbtn ${location.pathname === '/himachal' ? 'active-link' : ''}`}>Destinations</a> 

<div className="contact-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
                              <Link to="/abu">Abu Dhabi</Link>
                <Link to="/dubai">Dubai</Link>
            </div>
          </div>
            <Link to="/hotels">Hotels</Link>
        <Link to="/contact-us" className={location.pathname === '/contact-us' ? 'active-link' : ''}>Contact Us</Link>
          
        </nav>
  <Link to="/booknow">
        <button className="contact-book-btn">Book Now</button>
                    </Link>      </header>
    <div className="himachal-page">
      <div className="himachal-hero">
        <div className="himachal-hero-overlay">
          <h1>Explore Himachal Pradesh</h1>
          <p>Mountains, Adventures, Serenity – Your Himalayan escape</p>
        </div>
        <img src={himachalBanner} alt="himachal Banner" className="himachal-hero-img" />
      </div>

      <section className="himachal-info">
        <h2>Welcome to Himachal Pradesh</h2>
        <p>
         Himachal Pradesh is India's premier mountain destination, renowned for its breathtaking Himalayan landscapes, thrilling adventure sports, spiritual retreats, and serene valleys. From snow-capped peaks to lush green meadows and vibrant cultural experiences, Himachal has it all.
        </p>
      </section>

      {Object.entries(himachalData).map(([sectionTitle, items]) => (
        <section className="himachal-section" key={sectionTitle}>
          <h2>{formatTitle(sectionTitle)}</h2>
          <div className="himachal-cards-container">
            {items.map((item, index) => (
              <div className="himachal-card" key={index}>
             < img
                  src={imageMap[item.image] || item.image}
                  alt={item.name}
                />
                <h3>{item.name}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
    </>
  );
};

const formatTitle = (key) => {
  switch (key) {
    case 'Places': return 'Places';
    case 'Temples': return 'Temples';
    case 'Adventure': return 'Adventure';
    case 'Hotels': return 'Hotels & Resorts';
    default: return key;
  }
};

export default Himachal;
